import { ButtonComponent } from '../../UI/ButtonComponent/ButtonComponent';
import './cta.scss';
import { urls } from '../model';
import { ctaList } from './ctaModel';

const navigateToCategory = (url: string) => {
	globalThis.location.href = url;
};

const CategoryCta = ({ url, text }: { url: string; text: string }) => (
	<div className='cta'>
		<ButtonComponent
			onClick={() => navigateToCategory(url)}
			style='rounded-button secondary'
			icon={<i className='ri-arrow-right-s-line line-icon'></i>}
			text={text}
		></ButtonComponent>
	</div>
);

export const GotoPrivateProducts = ({ title }: { title?: string }) => (
	<CategoryCta url={urls.private} text={title || ctaList.PRIVATE} />
);

export const GotoCleanLabelProducts = ({ title }: { title?: string }) => (
	<CategoryCta url={urls.cleanLabel} text={title || ctaList.CLEAN_LABEL} />
);

export const GotoNextyProducts = () => <CategoryCta url={urls.nexty} text={ctaList.NEXTY} />;

export const GotoNewtoMarketProducts = () => (
	<CategoryCta url={urls.newtoMarket} text={ctaList.NEW_TO_MARKET} />
);

export const GotoLgbtqProducts = () => (
	<CategoryCta url={urls.lgbtqOwned} text={ctaList.LGBTQ_OWNED} />
);

export const GotoKehe = () => <CategoryCta url={urls.kehe} text={ctaList.KEHE} />;
